import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, FormGroup, Input, Button } from 'reactstrap'
import {
  loginLink
} from '../../../actions/adminActions'
import Form from '../../../modules/Form'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'

class AdminLogin extends Component {
  componentDidMount () {
    // check if cookie exists
  }

  render () {
    return (

      <div>
        <Container>
          <Row>
            <Col xs={{ size: 10, offset: 1 }} sm={{ size: 8, offset: 2 }} className='form-container'>
              <Form submit={this.props.loginLink} >
                <h2>Admin Login</h2>
                <FormGroup>
                  <Input type='email' name='email' id={'email'} required placeholder='Email' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <Button color='primary' disabled={this.props.admin.loading}>Request login link <span className='spinning' /></Button>
              </Form>
            </Col>
          </Row>
        </Container>

      </div>
    )
  }
};

AdminLogin.propTypes = {
  loginLink: PropTypes.func,
  admin: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginLink
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminLogin))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminLogin/AdminLogin.jsx